import PropTypes from "prop-types";
import React, { useState } from "react";
import styled, { withTheme } from "styled-components";
import { useRouter } from "next/router";
import Link from "next/link";
import Modal from "components/Modal";
import Button from "components/Button";
// import useVendorUser from "hooks/use-vendor-user";
// import useCustomerUser from "hooks/use-customer-user";
// import useVendorClient from "hooks/use-vendor-client";
// import useCustomerClient from "hooks/use-customer-client";
import ChangeRoleModal from "components/ChangeRoleModal";
import LogoutButtonLink from "./LogoutButtonLink";

const ActionItemWrapper = styled.div`
  cursor: default !important;
  padding: 0;
  opacity: 1;
  background-color: transparent;
  display: block;
  text-align: left;
  width: 100%;
  height: 1.25rem;
  z-index: 10;
  border: none;
  line-height: 0.875rem;
  margin-bottom: ${({ noBottomMargin }) =>
    noBottomMargin ? "0rem" : "0.9375rem"};

  a {
    padding: 0 !important;
  }

  a :hover {
    cursor: pointer;
    opacity: 0.5;
  }

  a :focus-visible {
    outline: 0.0625rem solid blue;
  }

  transition: ${({ theme }) => theme.opacityTransition};
`;

const IconWrapper = styled.div`
  margin-right: 0.75rem;
  display: inline-block;

  svg {
    margin-bottom: 0.0625rem;
  }
`;

const TextWrapper = styled.div`
  color: ${(props) => props.color || "#27272F"};
  font-size: ${(props) => {
    return props.fontSize || "0.875rem";
  }};
  margin-bottom: 0.125rem;
  font-weight: 600;
  display: inline-block;
  letter-spacing: 0.03125rem;
`;

const LoginContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LoginLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.themeColors.primary};
  border-radius: 3rem;
  color: ${({ theme }) => theme.themeColors.white};
  width: 100%;
  min-width: 12.5rem;
  height: 2.625rem;
  margin: 0.5rem 0 0.5rem 0;
`;

const ModalTextWrapper = styled.h3`
  align-self: flex-start;
  margin-bottom: 0.5em;
`;

const LinkWrapper = ({ children, href }) => {
  if (href) {
    return <Link href={href}>{children}</Link>;
  }
  return <div>{children}</div>;
};

LinkWrapper.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node.isRequired,
};

LinkWrapper.defaultProps = {
  href: "",
};

/* eslint-disable */

function ActionItem(props) {
  const {
    Icon,
    text,
    redirectUrl,
    fontSize,
    isLogout,
    isList,
    isLogin,
    providerId,
    noBottomMargin,
    theme,
  } = props;

  // const vendorClient = useVendorClient();
  // const customerClient = useCustomerClient();
  // const customerUser = useCustomerUser();
  // const vendorUser = useVendorUser();
  const { push, asPath } = useRouter();
  const isActive = asPath.length > 2 && redirectUrl.indexOf(asPath) > -1;
  const [modalShow, setModalShow] = useState(false);

  return (
    <ActionItemWrapper noBottomMargin={noBottomMargin} fontSize={fontSize}>
      {isLogout ? (
        <LogoutButtonLink
          color={theme.themeColors.darkGreen1}
          textContent="LOGOUT"
          Icon={Icon}
        />
      ) : (
        <LinkWrapper href={redirectUrl}>
          <a
            onClick={() => {
              if (isList) {
                setModalShow(true);
              }

              if (isLogin) {
                setModalShow(true);
              }
            }}
          >
            {Icon ? (
              <IconWrapper>
                <Icon color={isActive ? "#FC6020" : "#27272F"} />
              </IconWrapper>
            ) : null}
            <TextWrapper color={isActive ? "#FC6020" : "#27272F"}>
              {text?.toUpperCase()}
            </TextWrapper>
          </a>
        </LinkWrapper>
      )}
      {isLogin ? (
        <Modal close={() => setModalShow(false)} show={modalShow}>
          <LoginContentWrapper>
            <ModalTextWrapper>Log In</ModalTextWrapper>
            <LoginLinkWrapper>
              <Button onClick={() => push("/customer/auth")}>
                As a pet parent
              </Button>
            </LoginLinkWrapper>
            <LoginLinkWrapper>
              <Button onClick={() => push("/provider/auth")}>
                As a business owner
              </Button>
            </LoginLinkWrapper>
          </LoginContentWrapper>
        </Modal>
      ) : null}
      {isList ? (
        <ChangeRoleModal
          userTypeToAccess="provider"
          show={modalShow}
          close={() => setModalShow(false)}
        />
      ) : null}
    </ActionItemWrapper>
  );
}

export default withTheme(ActionItem);

/* eslint-enable */

ActionItem.propTypes = {
  Icon: PropTypes.func,
  text: PropTypes.string,
  redirectUrl: PropTypes.string,
  fontSize: PropTypes.string,
  isLogout: PropTypes.bool,
  isList: PropTypes.bool,
  isLogin: PropTypes.bool,
  providerId: PropTypes.string,
};

ActionItem.defaultProps = {
  Icon: null,
  text: "",
  redirectUrl: "",
  fontSize: "",
  isLogout: false,
  isList: false,
  isLogin: false,
  providerId: "",
};
